<!--
 * @Author: 岁岁平岁岁安·岁岁平安 1350797548@qq.com
 * @Date: 2024-07-17 15:56:31
 * @LastEditors: 岁岁平岁岁安·岁岁平安 1350797548@qq.com
 * @LastEditTime: 2024-07-17 16:43:41
 * @FilePath: \pc\coursearrange\src\ApprovalManagement\Map.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div>

        
      <el-card>
        <el-form style="display: flex;flex-wrap: wrap;padding-left: 20px;" >

            <el-form-item label="地域:"  style="display: flex;width: 33%; margin-bottom: 10px;" >
                <el-select v-model="value10" clearable filterable placeholder="请选择地域"  style="width: 100%;" @change="handleFindReadingStudent1">
                    <el-option v-for="item in optionsListtttt" :key="item.id" :label="item.dictValue" :value="item.dictType"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="学生:"  style="display: flex;width: 33%; margin-bottom: 10px;" >
                <el-select placeholder="请选择学生" v-model="value1"  style="width: 100%"  clearable  multiple filterable @change="handleFindReadingStudent2">
                    <el-option   v-for="item in valueList1"  :key="item.id"  :value="item.id"  :label="item.realname"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="老师:" style="display: flex;width: 33%; margin-bottom: 10px;" >
                <el-select placeholder="请选择老师" v-model="value2" style="width: 90%; margin-left: 26px;" clearable filterable>
                    <el-option v-for="item in optionList11" :key="item.id" :value="item.id" :label="item.realname"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="学科:" style="display: flex;width: 33%;" >
                <el-select   placeholder="请选择学科"  v-model="value3" style="width: 100%"  clearable  filterable>
                      <el-option  v-for="item in getStudentsArr_s"  :key="item.id"   :value="item.id"  :label="item.categoryName" ></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="区域:"  style="display: flex;width: 33%;" >
                <el-select v-model="value4" clearable filterable placeholder="请选择区域"  style="width: 100%;">
                    <el-option v-for="item in optionsListtt" :key="item.id" :label="item.dictValue" :value="item.id"></el-option>
                </el-select>
            </el-form-item>

            <!-- <el-form-item label="交通工具:"  style="display: flex;width: 33%;" >
                <el-select v-model="value5" clearable filterable placeholder="请选择交通工具"  style="width: 100%;">
                    <el-option v-for="item in optionsListt" :key="item.name" :label="item.name" :value="item.id"></el-option>
                </el-select>
            </el-form-item> -->


            <el-form-item label="时间类型:"  style="display: flex;width: 33%;" >
                <el-select v-model="value11" clearable filterable placeholder="请选择时间类型"  style="width: 100%;" @change="handleselectStudentSitevalue11">
                    <el-option v-for="item in optionsListttttt" :key="item.name" :label="item.name" :value="item.id"></el-option>
                </el-select>
            </el-form-item>


            <el-form-item label="星期:"  style="display: flex;width: 33%;" v-if="value11 === 1">
                <el-select v-model="value6" clearable filterable placeholder="请选择星期"  style="width: 100%;">
                    <el-option v-for="item in optionsListttt" :key="item.name" :label="item.name" :value="item.id"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="周:" style="display: flex;width: 33%;" v-if="value11 === 2">
                <el-date-picker style="margin-left: 13px;" v-model="value7" @change="getWeekNumber" type="week" format="yyyy 第 WW 周"   placeholder="选择周"  ></el-date-picker>
            </el-form-item>

            <el-form-item label="月:" style="display: flex;width: 33%;" v-if="value11 === 3">
                <el-date-picker style="margin-left: 13px;" v-model="value8"  value-format="yyyy-MM"  type="month" format="yyyy 年 MM 月" placeholder="选择月"></el-date-picker>
            </el-form-item>

            <div style="display: flex;justify-content: end;width: 100%;margin-bottom: 10px;">
                <!-- <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-download" @click="exportBtns">导出</el-button> -->
                <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-search"   @click="searchBtns">搜索</el-button>
                <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-close"   @click="clearBtns">清空</el-button>
            </div>

        </el-form>
      </el-card>  

      <div id="container" style=""></div>



      <div class="radius_box">
        <i class="el-icon-plus" style="font-size: 33px;cursor: pointer; z-index: 99999;"  v-if="!isExpand" @click="handleExpand"></i>
        <i class="el-icon-minus" style="font-size: 33px;cursor: pointer; z-index: 99999;" v-if="isExpand"  @click="handleRetract"></i>
        <div v-if="isExpand" class="icon-circle">
            <button class="icon-button" @click="handleIconClick(item.id)" v-for="item in iconList" :key="item.id">
                <el-tooltip effect="light" :content="item.name" placement="top-start">
                <img style="width: 30px;height: 30px;" :src="item.src" alt="item.name">
                 </el-tooltip>
            </button>
        </div>
      </div>




      <div v-if="showDistance" class="distance-box">
        <div style="position: absolute;top: 0;left: 0;width: 100%;z-index: 1111;">
            <i class="el-icon-circle-close" style="font-size: 33px;cursor: pointer; z-index: 1111; position: absolute;top: 4px;right: 6px;font-size: 31px;"  @click="handleshowDistanceclose"></i>
        </div>
        <el-card>
            <el-form>
                <el-form-item label="开始位置："  v-if="!showDistanceView">
                    <el-input v-model="form.longitude1" placeholder="请输入经度"></el-input>
                    <el-input style="margin-top: 7px;" v-model="form.latitude1" placeholder="请输入纬度"></el-input>
                </el-form-item>
                <el-form-item label="结束位置："  v-if="!showDistanceView">
                    <el-input v-model="form.longitude2" placeholder="请输入经度"></el-input>
                    <el-input style="margin-top: 7px;" v-model="form.latitude2" placeholder="请输入纬度"></el-input>
                </el-form-item>

                <el-form-item label="地址查询："  v-if="showDistanceView">
                    <el-select  clearable style="width: 100%;z-index: 111111111111;" v-model="form.startAddress"   filterable   remote reserve-keyword  placeholder="请输入起始地址关键词" :remote-method="remoteMethod1" :loading="loading1">
                        <el-option  v-for="item in options1" :key="item.value"  :label="item.label" :value="item.value">  </el-option>
                    </el-select>

                    <el-select clearable style="margin-top: 7px; width: 100%;z-index: 111111111111;"  v-model="form.endAddress"  filterable remote reserve-keyword  placeholder="请输入终点地址关键词"  :remote-method="remoteMethod2"  :loading="loading2">
                        <el-option v-for="item in options2" :key="item.value"  :label="item.label"  :value="item.value"> </el-option>
                    </el-select>
                </el-form-item>

                
                <el-form-item>
                    <div style="display: flex;justify-content: end; margin: 10px;">
                        <el-button type="primary" size="small" @click="handleStartDistance('view')">{{ showDistanceView ? '经纬度移动' : '地址移动' }}</el-button>
                        <el-button type="primary" size="small" @click="handleStartDistance('start')">开始移动</el-button>
                        <el-button type="primary" size="small" @click="handleStartDistance('reset')">重置移动</el-button>
                    </div>
                </el-form-item>
            </el-form>
        </el-card>
      </div>




      <div v-if="showCoordinate" class="distance-box-Coordinate">
        <div style="position: absolute;top: 0;left: 0;width: 100%;z-index: 1111;">
            <i class="el-icon-circle-close" style="font-size: 28px;cursor: pointer; z-index: 1111; position: absolute;top: 4px;right: 6px;font-size: 31px;"  @click="showCoordinate = false"></i>
        </div>
        <el-card>
            <div style="padding: 21px;">当前点击坐标为：{{contentinnerHTML}}</div>
        </el-card>
      </div>


      <div id="route-info-box" class="route-info-box" v-if="routeInfoVisible">
          <h3>路线规划详情</h3>
          <p>总距离：{{ routeInfo.distance }}</p>
          <!-- <p>预计时间：{{ routeInfo.duration }}</p> -->
          <h4>沿途路桥：</h4>
          <div style="text-align: start;">
              <div style="margin-top: 10px;" v-for="(step, index) in routeInfo.steps" :key="index">
                  {{ index + 1 }}. {{ step }}
              </div>
          </div>
          <el-button type="primary" size="small" style="margin-bottom: 19px; margin-top: 20px;" @click="startMovings">关闭弹窗</el-button>
          <el-button type="primary" size="small" style="margin-bottom: 19px; margin-top: 20px;" @click="startMoving">开始移动展示</el-button>
      </div>


      <div id="route-info-box" class="route-info-box" v-if="routeInfoVisibles">
        <h3>地铁路线规划详情</h3>
        <p>总距离：{{ routeInfo.distance }}</p>
        <p>预计时间：{{ routeInfo.duration }}</p>
        <h4>沿途站点：</h4>
        <div style="text-align: start;">
            <div style="margin-top: 10px;" v-for="(step, index) in routeInfo.steps" :key="index">
                {{ index + 1 }}. {{ step }}
            </div>
        </div>
        <el-button type="primary" size="small" style="margin-bottom: 19px; margin-top: 20px;" @click="startMovings">关闭弹窗</el-button>
    </div>

      
    </div>
</template>

<!-- 使用正确的腾讯地图 WebGL API URL -->
<!-- <script charset="utf-8" src="https://map.qq.com/api/gljs?v=1.exp&key=V2CBZ-VZZET-O6SXA-LIJJX-7NZ23-KWBXD"></script>-->
<!-- <script charset="utf-8" src="https://mapapi.qq.com/web/mapComponents/geoutils/1/modules/measure/index.min.js"></script>-->

<!-- 使用这个新的引入方式 -->
<script charset="utf-8" src="https://map.qq.com/api/gljs?v=1.exp&key=V2CBZ-VZZET-O6SXA-LIJJX-7NZ23-KWBXD"></script>
<script charset="utf-8" src="https://mapapi.qq.com/web/mapComponents/geoutils/1/modules/tools/tools.min.js"></script>


<script>
import {  ApiGetStudentList, } from "@/api/apiTask";
import { getTeachers, getSubject} from "@/api/fiveClassApi";
import loadingUtils from "../utils/loading";
import axios from "axios";
import apiBaseUrl from "../../config/api";



export default {
    props: {

    },
    data(){
        return{

           value10: 1,
           optionsListtttt: [],


           optionsListttttt: [
            { name: '星期', id: 1 },
            { name: '周', id: 2 },
            { name: '月', id: 3 },
           ],

           value11: '',

           routeInfoVisible: false,
           routeInfoVisibles: false,
           routeInfo: {
               distance: '',
               duration: '',
               steps: []
           },
           iconList: [
            // {
            //     id: 1,
            //     name: '移动展示',
            //     src: 'http://mz-app-develop.oss-cn-beijing.aliyuncs.com/mz_pc/juli.png'
            // },

            {
                id: 6,
                name: '规划路线',
                src: 'http://mz-app-develop.oss-cn-beijing.aliyuncs.com/mz_pc/%E6%97%85%E6%B8%B8%E5%B7%B4%E5%A3%AB_tour-bus.png'
            },
            
            {
                id: 2,
                name: '测量',
                src: 'http://mz-app-develop.oss-cn-beijing.aliyuncs.com/mz_pc/%E5%B0%BA%E5%AD%90_ruler.png'
            },
            {
                id: 3,
                name: '地图切换',
                src: 'http://mz-app-develop.oss-cn-beijing.aliyuncs.com/mz_pc/%E5%9C%B0%E7%90%83%E4%BB%AA_earth.png'
            },
           // {
           //     id: 4,
           //     name: '工具',
           //     src: 'http://mz-app-develop.oss-cn-beijing.aliyuncs.com/mz_pc/%E5%B7%A5%E5%85%B7_tool.png'
           // },
            // {
            //     id: 5,
            //     name: '坐标拾取',
            //     src: 'http://mz-app-develop.oss-cn-beijing.aliyuncs.com/mz_pc/%E7%82%B9%E5%87%BB_click.png'
            // },

            // {
            //     id: 7,
            //     name: '地铁规划',
            //     src: 'http://mz-app-develop.oss-cn-beijing.aliyuncs.com/mz_pc/juli.png'
            // },
            

            
            // {
            //     id: 8,
            //     name: '地铁样式',
            //     src: 'https://mz-app-develop.oss-cn-beijing.aliyuncs.com/mz_pc/%E5%9B%BD%E9%99%85%E5%8C%96_international.png'
            // },


            //  {
            //    id: 9,
            //    name: '测量学生距离',
            //    src: 'http://mz-app-develop.oss-cn-beijing.aliyuncs.com/mz_pc/%E5%B7%A5%E5%85%B7_tool.png'
            // },

          ],

          isExpand: false,

          valueList1: [],
          value1:[],

          optionList11: [],
          value2: '',

          getStudentsArr_s: [],
          value3: '',

          optionsListtt: [],
          value4: '',

          optionsListt: [
            { id:1, name: '地铁' },
            { id:2, name: '打车' },
          ],
          value5: '',


          optionsListttt: [
            { id:1, name: '星期一' },
            { id:2, name: '星期二' },
            { id:3, name: '星期三' },
            { id:4, name: '星期四' },
            { id:5, name: '星期五' },
            { id:6, name: '星期六' },
            { id:7, name: '星期日' },
          ],
          value6: '',

          value7: '',
          value8: '',

          weekNumber:[],


          center: [],
          Map:null,
          userMarker:null,
          marker: null,

          markerIcons: {
              green: 'http://mz-app-develop.oss-cn-beijing.aliyuncs.com/mz_pc/green.png',
              red: 'http://mz-app-develop.oss-cn-beijing.aliyuncs.com/mz_pc/red.png',
              yellow: 'http://mz-app-develop.oss-cn-beijing.aliyuncs.com/mz_pc/yellow.png',
              pink: 'http://mz-app-develop.oss-cn-beijing.aliyuncs.com/mz_pc/pink.png',
              blue: 'http://mz-app-develop.oss-cn-beijing.aliyuncs.com/mz_pc/blue.png',
          },
          studentMarkers: null, // 用于存储学生标记点的实例


          showDistance: false,
          form: {
            longitude1: '',
            latitude1: '',
            longitude2: '',
            latitude2: '',
            startAddress: '',
            endAddress: '',
          },


          movingMarker: null,
          animationTimer: null,

          isMoving: false,
          rotation: null,
          position: null,
          polylineLayer: null,


          showDistanceView: false,

          options1: [],
          options2: [],
          list1: [],
          list2: [],
          loading1: false,
          loading2: false,


          measureTool: null,


          showCoordinate: false,
          contentinnerHTML: '',
          
          routeMarker: null,

          isRouteDialogOpen: false, // 驾车路线弹窗状态
          isRouteDialogOpens: false, // 地铁路线弹窗状态
          drivingPath: null, // 保存驾车路线的路径


          selectedEnd: null,   // 动态选择的终点
         
          studentInfoWindows: {}, // 存储学生的 InfoWindow 实例
          

          openID: null, // 保存当前打开的 InfoWindow 的 openID
          openIDs: null, // 保存当前打开的 InfoWindow 的 openIDs

          records: [], // 学生坐标数据


          selectedItems:[],
          selectedItem:[],

          studentMarkersFromFindReadingStudent2: null, // 用于存储从 findReadingStudent2 方法创建的学生标记点的实例
          studentMarkersFromShowStudentMarkers: null, // 用于存储从 showStudentMarkers 方法创建的学生标记点的实例
          



          firstMarkerPosition: null, // 保存第一个标记点的位置
          secondMarkerPosition: null, // 保存第二个标记点的位置

          firstMarkerId: null, 
          secondMarkerId: null, 


        }
    },

    mounted(){


    //   ApiGetStudentList().then((res) => {  let { data } = res; this.valueList1 = data;  })
      this.handleFindReadingStudent()

      getTeachers().then( res => {   this.optionList11 = res.data })  
      getSubject().then(res => { this.getStudentsArr_s = res.data  })

 
    // document.addEventListener('touchmove', (event) => {
    //   event.preventDefault()
    // }, { passive: false })

      
      this.$nextTick(() => {
        this.initMap()
      })





    },  

    methods:{

        handleselectStudentSitevalue11(e){
            if (e === 1) {
                this.value7 = ''
                this.value8 = ''
            }
            if (e === 2) {
                this.value6 = '' 
                this.value8 = ''
            }
            if (e === 3) {
                this.value6 = ''
                this.value7 = ''
            }
        },

        handleselectStudentSite(value1,value2,value3) {
            let data = {
                teacherId: this.value2,      //1.2老师下拉返回id  老师id
                categoryId: this.value3,     //1.3学科下拉返回id 学科id
                regionName: this.value10,    //地域下拉返回dictType 地域id
                districtId: this.value4,     //区域下拉返回id 区域id
                // startDate: "2024-01-01",     //开始时间 yyyy-MM-dd
                // endDate: "2024-02-01",       //结束时间 yyyy-MM-dd
                dateType: this.value11,           //时间类型 1星期 2周 3月 4自定义
                yearDate: value2 ? Number(value2) : '',       //年 时间类型为2,3时传
                monthDate: this.value11 === 3 ? Number(value3) : '',          //月 时间类型为3时传
                weekDate: this.value11 === 2  ? Number(value3) : '',        //第几周 时间类型为2时传
                whatDay: value1 ? Number(value1) : '',          //星期几 时间类型为1时传
            }
            axios.post(`${apiBaseUrl}/student/selectStudentSite`, data,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then(res => {
                if (res.data.code == 200) {
                    if(res.data.data.length > 0){

                        this.records = res.data.data.map((item) => {
                            return {
                                id: item.id,
                                name: item.realname,
                                lat: item.precisionLng,
                                lng: item.latitude,
                                subject: item.subject, 
                                address: item.address,
                                status: 'blue' // 强制设置为蓝色
                            };
                        });

                        this.showStudentMarkers(this.records);

                    }else{
                        this.records = []
                        this.showStudentMarkers(this.records);
                    }
                } else {
                    this.$message({  message: res.data.message,   type: "error"})
                }
                }).catch(err => {
                 this.$message({  message: err,   type: "error"})
            })
        },

        handleFindReadingStudent1(){

           // 获取学生
            axios.get(`${ apiBaseUrl }/student/findReadingStudent?regionName=${this.value10} `, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{ 
                if(res.data.code === 200){
                    this.valueList1 = res.data.data
                }else{
                    this.$message({ message: res.data.msg , type: "error" })
                }
           }).catch((err)=>{
                this.$message({ message: err , type: "error" })
           })

          //  获取老师 
           axios.get(`${ apiBaseUrl }/schedule/teacherDiagnosisListByRegionName?regionName=${this.value10} `, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{ 
                if(res.data.code === 200){
                    this.optionList11 = res.data.data
                }
           }).catch((err)=>{
                this.$message({ message: err , type: "error" })
           })

         // 获取区域
           this.optionsListtttt.map((item) => {
                if(this.value10 === item.dictType) {
                    axios.get(`${ apiBaseUrl }/dict/getDictionarySon/${item.id} `, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{ 
                            if(res.data.code === 200){
                                this.optionsListtt = res.data.data
                            }else{
                                this.optionsListtt = []
                            }
                    }).catch((err)=>{
                            this.$message({ message: err , type: "error" })
                    })
                }
           })


           const selectedItem = this.optionsListtttt.find(item => item.dictType === this.value10);
           this.selectedItem = selectedItem
           console.log(this.selectedItem,'地域item===>>>>');

    

           this.Map.easeTo({
                center: new TMap.LatLng(this.selectedItem ? this.selectedItem.latitude : 39.819988, this.selectedItem ? this.selectedItem.precision : 116.347422),
                zoom: 12, // 设置适当的缩放级别
                pitch: 0,
                rotation: 0
            }, {
                duration: 1000 // 动画持续时间
            });

           this.haandleLocateUser(this.selectedItem ? this.selectedItem.latitude : 39.819988, this.selectedItem ? this.selectedItem.precision : 116.347422)
     
        },



        handleFindReadingStudent2() {
            const selectedItems = this.valueList1.filter(item => this.value1.includes(item.id));
            this.selectedItems = selectedItems;
            console.log(this.selectedItems, '学生item===>>>>');

            if (this.selectedItems.length > 0) {
                // 检查是否有经纬度为空的学生
                const invalidItems = this.selectedItems.filter(item => !item.precisionLng || !item.latitude);
                if (invalidItems.length > 0) {
                    this.$message.warning('部分学生的经纬度信息缺失，请检查数据！');
                    return; // 直接返回，不继续执行
                }

                // 准备标记点样式
                const styles = {
                    yellow: new TMap.MarkerStyle({
                        width: 35,
                        height: 40,
                        anchor: { x: 16, y: 32 },
                        src: this.markerIcons.yellow
                    })
                };

                // 准备标记点数据
                const geometries = this.selectedItems.map(item => ({
                    id: item.id,
                    position: new TMap.LatLng(item.latitude, item.precisionLng),
                    styleId: 'yellow',
                    properties: {
                        id: item.id,
                        title: item.realname || '',
                        subject: item.subject || '',
                        address: item.address || '',
                        age: item.age || '',
                    }
                }));

                // 创建多个标记点（不清除其他标记点）
                if (this.studentMarkersFromFindReadingStudent2) {
                    this.studentMarkersFromFindReadingStudent2.setMap(null);
                }
                this.studentMarkersFromFindReadingStudent2 = new TMap.MultiMarker({
                    map: this.Map,
                    styles: styles,
                    geometries: geometries
                });

                // 为每个标记点添加 hover 事件
                this.studentMarkersFromFindReadingStudent2.on('hover', (evt) => {
                    console.log(evt, 'hover----------》》》');

                    const { id, position, properties } = evt.geometry || {};
                    if (!id || !position || !properties) {
                        console.warn('hover 事件的 geometry 数据不完整:', evt);
                        return;
                    }

                    // 如果该标记的信息窗口不存在，则创建
                    if (!this.studentInfoWindows[id]) {
                        this.studentInfoWindows[id] = new TMap.InfoWindow({
                            map: this.Map,
                            position: position,
                            offset: new TMap.Point(-2, -25),
                            content: `
                                <div style="text-align: start;">
                                    <h4 style="margin: 0 0 5px;font-weight: bold;">学生信息</h4>
                                    <div style="margin: 0; text-align: start; width: 100%; ">姓名: ${properties.title}</div>
                                    <div style="margin: 5px 0 0;text-align: start;width: 100%;">科目: ${properties.subject}</div>
                                    <div style="margin: 5px 0 0;text-align: start;width: 100%;">地址: ${properties.address}</div>
                                </div>
                            `,
                            zIndex: 999
                        });
                    } else {
                        // 更新已有弹窗的内容
                        this.studentInfoWindows[id].setContent(`
                            <div style="text-align: start;">
                                <h4 style="margin: 0 0 5px;font-weight: bold;">学生信息</h4>
                                <div style="margin: 0;text-align: start;width: 100%;">姓名: ${properties.title}</div>
                                <div style="margin: 5px 0 0;text-align: start;width: 100%;">科目: ${properties.subject}</div>
                                <div style="margin: 5px 0 0;text-align: start;width: 100%;">地址: ${properties.address}</div>
                            </div>
                        `);
                    }

                    // 打开当前标记的信息窗口
                    this.studentInfoWindows[id].open();
                    this.studentInfoWindows[id].setPosition(position);

                    // 保存当前打开的 InfoWindow 的 ID
                    this.openIDs = evt.geometry;
                });

                this.studentMarkersFromFindReadingStudent2.on('mouseout', (evt) => {
                    console.log(this.openIDs, 'mouseout----------》》》');

                    const { id } = this.openIDs;

                    // 关闭当前打开的信息窗口
                    if (this.studentInfoWindows[id]) {
                        this.studentInfoWindows[id].close();
                    }

                    // 清空 openID
                    this.openIDs = null;
                });

                // 调整地图视野以包含所有标记点
                const bounds = new TMap.LatLngBounds();
                geometries.forEach(geo => bounds.extend(geo.position));
                this.Map.fitBounds(bounds, {
                    padding: 100 // 设置边距，确保标记点不会太靠近地图边缘
                });

                // 为每个标记点绑定点击事件
                this.studentMarkersFromFindReadingStudent2.on('click', (evt) => {
                    const { id, position, properties } = evt.geometry || {};
                    if (!id || !position || !properties) {
                        console.warn('click 事件的 geometry 数据不完整:', evt);
                        return;
                    }
                    console.log(id, position, properties, '为每个标记点绑定点击事件===222222222222222222222222===========>>>',evt.geometry)     
                    this.handleMarkerClick(position, properties.title,properties.id);
                });


            } else {
                this.clearBtns(1);
            }
        },


        handleFindReadingStudent() {
            // 获取地域
            axios.get(`${ apiBaseUrl }/dict/getDictionary/${'地域'} `, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{ 
               this.optionsListtttt = res.data.data
               this.handleFindReadingStudent1()
            })
        },


        handleselectStudentDistance(start,end) {

            console.log(start,end,'start,end')
           
            // 获取两个学生之间的
            axios.post(`${apiBaseUrl}/student/selectStudentDistance`, { startStudentId: start, endStudentId: end }, { headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then(res => {
                if (res.data.code == 200) {
                    let reslut = res.data.data
                    console.log(reslut, '学生之前返回的~`')
                     // 弹窗展示驾车和公交距离
                     this.$confirm(`
                        <div>
                            <h4>路线信息</h4>
                            ${reslut.map((item, index) => `
                                <div style="margin-bottom: 10px;">
                                    <p><strong>路线 ${index + 1}:</strong></p>
                                    <p>出行方式：${item.mode === '1' ? '驾车' : item.mode === '2' ? '骑行' : item.mode === '3' ? '公交' : ''}</p>
                                    <p>公里数：${item.distance ? item.distance : ''}</p>
                                    <p>单位分钟：${item.duration ? item.duration : ''}</p>
                                </div>
                            `).join('')}
                        </div>
                    `, '路线详情', {
                        dangerouslyUseHTMLString: true,
                        confirmButtonText: '确定',
                    });
                } else {
                    this.$message({  message: res.data.message,   type: "error"})
                }
                }).catch(err => {
                 this.$message({  message: err,   type: "error"})
            })
        },


        getRoutes(type, startPosition, endPosition) {
            return new Promise((resolve, reject) => {
                const callbackName = `jsonp_route_${type}_${Math.random().toString(36).substr(2, 9)}`;
                const script = document.createElement('script');

                const baseUrl = 'https://apis.map.qq.com/ws/direction/v1';
                const url = `${baseUrl}/${type}/?from=${startPosition.lat},${startPosition.lng}&to=${endPosition.lat},${endPosition.lng}&key=V2CBZ-VZZET-O6SXA-LIJJX-7NZ23-KWBXD&output=jsonp&callback=${callbackName}`;

                window[callbackName] = (response) => {
                    console.log('地铁路线规划接口返回数据:', response); // 调试日志

                    if (response.status === 0) {
                        const route = response.result.routes[0];
                        const path = this.decodePolyline(route.polyline);

                        // 确保 steps 是数组
                        const steps = Array.isArray(route.steps) ? route.steps.map((step) => {
                            if (step.mode === 'TRANSIT') {
                                return `乘坐${step.lines[0].title} (${step.lines[0].stations.length}站)`;
                            }
                            return step.instruction;
                        }) : [];

                        resolve({
                            duration: route.duration,
                            distance: route.distance,
                            steps: steps, // 确保 steps 是数组
                            path: path // 确保 path 是解析后的数组
                        });
                    } else {
                        reject(new Error(response.message));
                    }

                    document.body.removeChild(script);
                    delete window[callbackName];
                };

                script.onerror = () => {
                    reject(new Error(`${type}路线规划服务出错`));
                    document.body.removeChild(script);
                    delete window[callbackName];
                };

                script.src = url;
                document.body.appendChild(script);
            });
        },  

        remoteMethod1(query) {
            if (query !== '') {
                this.loading1 = true;
                
                // 创建JSONP回调函数名
                const callbackName = 'jsonp_' + Math.random().toString(36).substr(2, 9);
                
                // 创建script标签
                const script = document.createElement('script');
                const url = `https://apis.map.qq.com/ws/place/v1/search?keyword=${encodeURIComponent(query)}&boundary=region(全国,0)&key=V2CBZ-VZZET-O6SXA-LIJJX-7NZ23-KWBXD&page_size=20&output=jsonp&callback=${callbackName}`;
                
                // 设置JSONP回调
                window[callbackName] = (response) => {
                    this.loading1 = false;
                    if (response.status === 0) {
                        this.options1 = response.data.map(item => ({
                            value: {
                                lat: item.location.lat,
                                lng: item.location.lng
                            },
                            label: item.title,
                            address: item.address
                        }));
                    } else {
                        this.$message.error(response.message);
                    }
                    
                    // 清理
                    document.body.removeChild(script);
                    delete window[callbackName];
                };
                
                // 处理错误情况
                script.onerror = () => {
                    this.loading1 = false;
                    this.$message.error('地址搜索服务出错');
                    document.body.removeChild(script);
                    delete window[callbackName];
                };
                
                script.src = url;
                document.body.appendChild(script);
            } else {
                this.options1 = [];
            }
        },

        remoteMethod2(query) {
            if (query !== '') {
                this.loading2 = true;
                
                // 创建JSONP回调函数名
                const callbackName = 'jsonp_' + Math.random().toString(36).substr(2, 9);
                
                // 创建script标签
                const script = document.createElement('script');
                const url = `https://apis.map.qq.com/ws/place/v1/search?keyword=${encodeURIComponent(query)}&boundary=region(全国,0)&key=V2CBZ-VZZET-O6SXA-LIJJX-7NZ23-KWBXD&page_size=20&output=jsonp&callback=${callbackName}`;
                
                // 设置JSONP回调
                window[callbackName] = (response) => {
                    this.loading2 = false;
                    if (response.status === 0) {
                        this.options2 = response.data.map(item => ({
                            value: {
                                lat: item.location.lat,
                                lng: item.location.lng
                            },
                            label: item.title,
                            address: item.address
                        }));
                    } else {
                        this.$message.error(response.message);
                    }
                    
                    // 清理
                    document.body.removeChild(script);
                    delete window[callbackName];
                };
                
                // 处理错误情况
                script.onerror = () => {
                    this.loading2 = false;
                    this.$message.error('腾讯地图搜索服务出错');
                    document.body.removeChild(script);
                    delete window[callbackName];
                };
                
                script.src = url;
                document.body.appendChild(script);
            } else {
                this.options2 = [];
            }
        },

        handleshowDistanceclose(){
            this.showDistance = false
            this.form.longitude1 = ''
            this.form.latitude1 = ''
            this.form.longitude2 = ''
            this.form.latitude2 = ''
        },

        handleStartDistance(value) {
            if(value === 'view') {
                this.showDistanceView = !this.showDistanceView
            }

            if(value === 'start') {
                if (this.isMoving) return;
                
                let startPoint, endPoint;
                
                if (this.showDistanceView) {
                    // 使用地址搜索的结果
                    if (!this.form.startAddress || !this.form.endAddress) {
                        this.$message.error('请选择起点和终点地址');
                        return;
                    }
                    startPoint = new TMap.LatLng(
                        this.form.startAddress.lat,
                        this.form.startAddress.lng
                    );
                    endPoint = new TMap.LatLng(
                        this.form.endAddress.lat,
                        this.form.endAddress.lng
                    );
                } else {
                    // 使用经纬度
                    if (!this.form.latitude1 || !this.form.longitude1 || 
                        !this.form.latitude2 || !this.form.longitude2) {
                        this.$message.error('请输入完整的起点和终点坐标');
                        return;
                    }
                    startPoint = new TMap.LatLng(
                        Number(this.form.latitude1),
                        Number(this.form.longitude1)
                    );
                    endPoint = new TMap.LatLng(
                        Number(this.form.latitude2),
                        Number(this.form.longitude2)
                    );
                }

                // 使用JSONP方式请求路线规划
                const callbackName = 'jsonp_route_' + Math.random().toString(36).substr(2, 9);
                const script = document.createElement('script');
                const url = `https://apis.map.qq.com/ws/direction/v1/driving/?from=${startPoint.lat},${startPoint.lng}&to=${endPoint.lat},${endPoint.lng}&key=V2CBZ-VZZET-O6SXA-LIJJX-7NZ23-KWBXD&output=jsonp&callback=${callbackName}`;

                // 设置JSONP回调
                window[callbackName] = (response) => {
                    if (response.status === 0) {
                        const route = response.result.routes[0];
                        const path = [];
                        
                        // 解析返回的路线坐标
                        route.polyline.forEach((coord, index) => {
                            if (index % 2 === 0) {
                                path.push(new TMap.LatLng(
                                    route.polyline[index],
                                    route.polyline[index + 1]
                                ));
                            }
                        });

                        // 创建路线图层
                        if (this.polylineLayer) {
                            this.polylineLayer.setMap(null);
                        }
                        
                        this.polylineLayer = new TMap.MultiPolyline({
                            map: this.Map,
                            styles: {
                                style_blue: new TMap.PolylineStyle({
                                    color: '#2A88FF',
                                    width: 8,
                                    borderWidth: 3,
                                    borderColor: '#0569FF',
                                    lineCap: 'round'
                                })
                            },
                            geometries: [{
                                id: 'path1',
                                styleId: 'style_blue',
                                paths: path
                            }]
                        });

                        // 创建移动标记
                        if (this.movingMarker) {
                            this.movingMarker.setMap(null);
                        }

                        this.movingMarker = new TMap.MultiMarker({
                            map: this.Map,
                            styles: {
                                'car': new TMap.MarkerStyle({
                                    width: 48,
                                    height: 72,
                                    anchor: { x: 24, y: 36 },
                                    faceTo: 'map',
                                    src: 'https://mapapi.qq.com/web/mapComponents/componentsTest/zyTest/static/model_taxi.png'
                                })
                            },
                            geometries: [{
                                id: 'car',
                                styleId: 'car',
                                position: path[0]
                            }]
                        });

                        // 设置地图视角
                        this.Map.easeTo({
                            center: path[0],
                            zoom: 16,
                            pitch: 45
                        }, {
                            duration: 1000
                        });

                        // 开始移动动画
                        setTimeout(() => {
                            this.movingMarker.moveAlong({
                                car: {
                                    path: path,
                                    speed: 80,  // 增加速度
                                    delay: 50   // 减少延迟使移动更流畅
                                }
                            }, {
                                autoRotation: true,
                                smooth: true
                            });

                            this.isMoving = true;

                            // 移动过程中的事件监听
                            this.movingMarker.on('moving', (e) => {
                                if (!e.car || !e.car.passedLatLngs.length) return;

                                const lastIdx = e.car.passedLatLngs.length - 1;
                                const currentPos = e.car.passedLatLngs[lastIdx];

                                // 更新相机位置，使其更紧密地跟随车辆
                                this.Map.easeTo({
                                    center: currentPos, // 直接跟随当前位置，不再预测前方位置
                                    rotation: e.car.angle, // 保持与车辆相同的方向
                                    pitch: 60, // 增加俯仰角，提供更好的视角
                                    zoom: 18 // 增加缩放级别，使视角更近
                                }, {
                                    duration: 100 // 减少相机过渡时间，使跟随更平滑
                                });

                                // 更新已经走过的路线样式
                                this.polylineLayer.updateGeometries([{
                                    id: 'path1',
                                    styleId: 'style_blue',
                                    paths: path
                                }]);
                            });

                            // 移动结束事件
                            this.movingMarker.on('move_ended', () => {
                                this.isMoving = false;
                                this.$message.success('移动完成');
                                
                                // 重置地图视角，提供更好的结束视角
                                this.Map.easeTo({
                                    pitch: 0,
                                    rotation: 0,
                                    zoom: 16,
                                    center: path[path.length - 1] // 居中显示终点位置
                                }, {
                                    duration: 1000
                                });
                            });
                        }, 500);
                    } else {
                        this.$message.error(response.message || '路线规划失败');
                    }

                    // 清理JSONP
                    document.body.removeChild(script);
                    delete window[callbackName];
                };

                script.onerror = () => {
                    this.$message.error('路线规划服务出错');
                    document.body.removeChild(script);
                    delete window[callbackName];
                };

                script.src = url;
                document.body.appendChild(script);
            }

            if(value === 'reset') {
                // 停止移动
                if (this.movingMarker) {
                    this.movingMarker.stopMove();
                    this.movingMarker.setMap(null);
                }
                
                // 清除路线
                if (this.polylineLayer) {
                    this.polylineLayer.setMap(null);
                }

                this.isMoving = false;

                // 重置地图视图
                this.Map.easeTo({
                    center: new TMap.LatLng(39.819988, 116.347422),
                    zoom: 16,
                    rotation: 0,
                    pitch: 0
                }, {
                    duration: 1000
                });
            }
        },

        isValidLatLng(lat, lng) {
            return lat >= -90 && lat <= 90 && lng >= -180 && lng <= 180;
        },

        decodePolyline(encodedPolyline) {
            const polyline = [];
            for (let i = 2; i < encodedPolyline.length; i++) {
                encodedPolyline[i] = encodedPolyline[i - 2] + encodedPolyline[i] / 1e6;
            }
            for (let i = 0; i < encodedPolyline.length; i += 2) {
                polyline.push(new TMap.LatLng(encodedPolyline[i], encodedPolyline[i + 1]));
            }
            return polyline;
        },

        handleIconClick(iconNumber,event) {
            if (event) {
                event.preventDefault();
                event.stopPropagation();
            }

            if(iconNumber === 9){

                 // 如果已经存在路线，则清除路线
                if (this.polylineLayer) {
                    this.polylineLayer.setMap(null); // 清除路线
                    this.polylineLayer = null; // 重置路线图层
                    this.$message.info('已清除路线');
                    return; // 直接返回，不执行后续逻辑
                }

                let firstMarkerPosition = null; // 用于保存第一个学生的位置信息

                if(this.studentMarkersFromShowStudentMarkers){
                    this.studentMarkersFromShowStudentMarkers.on('click', async (evt) => {
                        const { id, position, properties } = evt.geometry || {};
                        if (!id || !position || !properties) {
                            console.warn('click 事件的 geometry 数据不完整:', evt);
                            return;
                        }

                        if (!firstMarkerPosition) {
                            // 保存第一个学生的位置信息
                            firstMarkerPosition = position;
                            console.log('已选择第一个学生:', properties.title, firstMarkerPosition);
                            this.$message.info(`已选择第一个学生: ${properties.title}`);
                        } else {
                            // 保存第二个学生的位置信息
                            const secondMarkerPosition = position;
                            console.log('已选择第二个学生:', properties.title, secondMarkerPosition);
                            this.$message.info(`已选择第二个学生: ${properties.title}`);

                            // 模拟假数据
                            const drivingRoute = {
                                distance: 12000, // 模拟驾车距离（单位：米）
                                duration: 900, // 模拟驾车时间（单位：秒）
                                path: [firstMarkerPosition, secondMarkerPosition] // 模拟路线
                            };

                            // 弹窗展示驾车和公交距离
                            this.$confirm(`
                                <div>
                                    <h4>路线信息</h4>
                                    <p>驾车距离: ${this.formatDistance(12000)}</p>
                                    <p>公交距离: ${this.formatDistance(15000)}</p>
                                </div>
                            `, '路线详情', {
                                dangerouslyUseHTMLString: true,
                                confirmButtonText: '确定',
                            });

                            // 绘制驾车路线
                            this.showSelectedRoutes(drivingRoute.path);

                            // 重置第一个学生的位置
                            firstMarkerPosition = null;
                        }
                    });
                }else{
                    this.$message.warning('请先点击地图选择学生');
                }
            }

            if (iconNumber === 8) {
                console.log(this.Map,'this.Map')
                this.Map.setMapStyleId('style5'); // 夜间风格
            }

            if (iconNumber === 7) {
               // 检查是否选择了终点
                if (!this.selectedEnd) {
                    this.$message.warning('请先选择终点标记');
                    return; // 停止后续逻辑
                }

                const startPosition = new TMap.LatLng(39.819988, 116.347422); // 示例起点
                const endPosition = new TMap.LatLng(this.selectedEnd.lat, this.selectedEnd.lng);

                if (!this.isValidLatLng(startPosition.lat, startPosition.lng) || !this.isValidLatLng(endPosition.lat, endPosition.lng)) {
                    this.$message.warning('起点或终点的经纬度值无效，请检查输入');
                    return;
                }

                // 清除现有路线和动画
                if (this.polylineLayer) {
                    this.polylineLayer.setMap(null);
                    this.polylineLayer = null;
                }
                if (this.movingMarker) {
                    this.movingMarker.stopMove();
                    this.movingMarker.setMap(null);
                    this.movingMarker = null;
                }
                if (this.routeMarker) {
                    this.routeMarker.setMap(null);
                    this.routeMarker = null;
                }

                // 设置弹窗状态为打开
                this.isRouteDialogOpens = true;

                // 添加起点和终点标记
                this.addStartEndMarkers(startPosition, endPosition);

                // 请求地铁路线
                this.getRoutes('transit', startPosition, endPosition).then((transitRoute) => {
                    console.log('解析后的地铁路线:', transitRoute.path); // 调试日志

                    // 显示地铁路线在地图上
                    this.showSelectedRoutes(transitRoute.path);

                    // 更新路线信息
                    this.routeInfo = {
                        distance: this.formatDistance(transitRoute.distance),
                        duration: this.formatDuration(transitRoute.duration),
                        steps: Array.isArray(transitRoute.steps) ? transitRoute.steps : [] // 确保 steps 是数组
                    };

                    // 显示路线详情
                    this.routeInfoVisibles = true;

                    this.$message.success('地铁路线规划完成');
                })
                .catch((error) => {
                    console.error('地铁路线规划错误:', error);
                    this.isRouteDialogOpens = false; // 重置弹窗状态
                    this.routeInfoVisibles = false;
                    this.$message.error('获取地铁路线信息失败');
                }).finally(() => {
                    this.isRouteDialogOpens = false; // 重置弹窗状态
                });
            }

        
            if (iconNumber === 6) {

                if (!this.selectedEnd) {
                    this.$message.warning('请先选择终点标记');
                    return; // 停止后续逻辑
                }

                // 清除现有路线和动画
                if (this.polylineLayer) {
                    this.polylineLayer.setMap(null);
                    this.polylineLayer = null;
                }
                if (this.movingMarker) {
                    this.movingMarker.stopMove();
                    this.movingMarker.setMap(null);
                    this.movingMarker = null;
                }
                if (this.routeMarker) {
                    this.routeMarker.setMap(null);
                    this.routeMarker = null;
                }

                // 设置弹窗状态为打开
                this.isRouteDialogOpen = true;

                const startPosition = new TMap.LatLng(39.819988, 116.347422);
                const endPosition = new TMap.LatLng(this.selectedEnd.lat, this.selectedEnd.lng);

                if (!this.isValidLatLng(startPosition.lat, startPosition.lng) || !this.isValidLatLng(endPosition.lat, endPosition.lng)) {
                    this.$message.warning('起点或终点的经纬度值无效，请检查输入');
                    return;
                }

                 // 添加起点和终点标记
                this.addStartEndMarkers(startPosition, endPosition);

                  // 请求驾车路线
                this.getRoute('driving', startPosition, endPosition).then((drivingRoute) => {
                        // 保存驾车路线数据供 iconNumber === 1 使用
                        this.drivingPath = drivingRoute.path;

                        // 显示路线在地图上
                        this.showSelectedRoute(this.drivingPath);

                        // 保存路线信息到 `routeInfo`
                        this.routeInfo = {
                            distance: this.formatDistance(drivingRoute.distance),
                            duration: this.formatDuration(drivingRoute.duration),
                            steps: drivingRoute.steps
                        };

                        // 显示路线详情
                        this.routeInfoVisible = true;

                        this.$message.success('驾车路线规划完成');
                    })
                    .catch((error) => {
                        console.error('路线规划错误:', error);
                        this.isRouteDialogOpen = false; // 重置弹窗状态
                        this.routeInfoVisible = false;
                        this.$message.error('获取路线信息失败');
                    }).finally(() => {
                        this.isRouteDialogOpen = false; // 重置弹窗状态
                    });

            }

            if (iconNumber === 3) {
                // 判断是不是卫星图如果是卫星图则切换为普通图
                if (this.Map.getBaseMap().type === 'satellite') {
                    this.Map.setBaseMap({ type: 'vector' });
                } else {
                    this.Map.setBaseMap({ type: 'satellite' });
                }
            }

            if(iconNumber === 5){
                this.showCoordinate = !this.showCoordinate;
                this.showDistance = false;
            }

            if (iconNumber === 1) {
                // 如果正在移动，则停止
                if (this.isMoving) {
                    if (this.movingMarker) {
                        this.movingMarker.stopMove();
                        this.movingMarker.setMap(null);
                    }
                    this.isMoving = false;
                    return;
                }

                // 获取当前规划路线的路径
                const geometry = this.polylineLayer.getGeometries()[0];
                const path = geometry.paths;

                // 创建移动标记
                if (this.movingMarker) {
                    this.movingMarker.setMap(null);
                }

                this.movingMarker = new TMap.MultiMarker({
                    map: this.Map,
                    styles: {
                        'car': new TMap.MarkerStyle({
                            width: 48,
                            height: 72,
                            anchor: { x: 24, y: 36 },
                            faceTo: 'map',
                            src: 'https://mapapi.qq.com/web/mapComponents/componentsTest/zyTest/static/model_taxi.png'
                        })
                    },
                    geometries: [{
                        id: 'car',
                        styleId: 'car',
                        position: this.drivingPath[0]
                    }]
                });

                // 设置地图视角
                this.Map.easeTo({
                    center: this.drivingPath[0],
                    zoom: 16,
                    pitch: 45
                }, {
                    duration: 1000
                });

                // 开始移动动画
                setTimeout(() => {
                    this.movingMarker.moveAlong({
                        car: {
                            path: this.drivingPath,
                            speed: 80,  // 设置速度
                            delay: 50   // 减少延迟使移动更流畅
                        }
                    }, {
                        autoRotation: true,
                        smooth: true
                    });

                    this.isMoving = true;

                    // 移动过程中的事件监听
                    this.movingMarker.on('moving', (e) => {
                        if (!e.car || !e.car.passedLatLngs.length) return;

                        const lastIdx = e.car.passedLatLngs.length - 1;
                        const currentPos = e.car.passedLatLngs[lastIdx];

                        // 更新相机位置，使其更紧密地跟随车辆
                        this.Map.easeTo({
                            center: currentPos, // 直接跟随当前位置
                            rotation: e.car.angle, // 保持与车辆相同的方向
                            pitch: 60, // 增加俯仰角，提供更好的视角
                            zoom: 18 // 增加缩放级别，使视角更近
                        }, {
                            duration: 100 // 减少相机过渡时间，使跟随更平滑
                        });

                    });

                    // 移动结束事件
                    this.movingMarker.on('move_ended', () => {
                    this.isMoving = false;
                    this.$message.success('移动完成');
                    
                    // 重置地图视角，提供更好的结束视角
                    this.Map.easeTo({
                        pitch: 0,
                        rotation: 0,
                        zoom: 16,
                        center: this.drivingPath[this.drivingPath.length - 1] // 居中显示终点位置
                    }, {
                        duration: 1000
                    });
                });
                }, 500);
            }


            if (iconNumber === 2) {
                try {
                    if (!this.measureTool) {
                        // 尝试重新初始化测量工具
                        if (TMap && TMap.tools && TMap.tools.MeasureTool) {
                            this.measureTool = new TMap.tools.MeasureTool({
                                map: this.Map,
                                showResult: true,
                                cursor: 'crosshair',
                                drawStyle: {
                                    color: '#1791fc',
                                    opacity: 1,
                                    weight: 4
                                }
                            });
                        } else {
                            throw new Error('测量工具未加载');
                        }
                    }
                    this.measureTool.measureDistance();
                } catch (error) {
                    console.error('测量工具错误:', error);
                    this.$message.error('测量工具启动失败，请确保已正确加载测量工具库');
                }
            }
        },

        handleExpand(){
          this.isExpand = true
        },

        handleRetract(){
          this.isExpand = false
        },

        clearBtns(type){
            if (type === 1) {
                if (this.studentMarkersFromFindReadingStudent2) {
                    this.studentMarkersFromFindReadingStudent2.setMap(null);
                    this.studentMarkersFromFindReadingStudent2 = null;
                }
                
                if (this.studentMarkersFromFindReadingStudent2) {
                    Object.values(this.studentMarkersFromFindReadingStudent2).forEach((infoWindow) => {
                        infoWindow.close();
                    });
                }
            }else{
                // 清除学生标记
                if (this.studentMarkersFromShowStudentMarkers) {
                    this.studentMarkersFromShowStudentMarkers.setMap(null);
                    this.studentMarkersFromShowStudentMarkers = null;
                }

                // 清除学生的弹窗
                if (this.studentMarkersFromShowStudentMarkers) {
                    Object.values(this.studentMarkersFromShowStudentMarkers).forEach((infoWindow) => {
                        infoWindow.close();
                    });
                }

                this.value1 = []
                if (this.studentMarkersFromFindReadingStudent2) {
                    this.studentMarkersFromFindReadingStudent2.setMap(null);
                    this.studentMarkersFromFindReadingStudent2 = null;
                }
                if (this.studentMarkersFromShowStudentMarkers) {
                    this.studentMarkersFromShowStudentMarkers.setMap(null);
                    this.studentMarkersFromShowStudentMarkers = null;
                }

            }
                // 清空表单数据
            this.value1 = []
            this.value2 = ''
            this.value3 = ''
            this.value4 = ''
            this.value5 = ''
            this.value6 = ''
            this.value7 = ''
            this.value8 = ''
            this.value10 = 1
            this.value11 = ''
            this.weekNumber = []
            this.routeInfoVisible = false
            this.selectedEnd = null

       
            // 清除路线和移动标记
            if (this.polylineLayer) {
                this.polylineLayer.setMap(null);
                this.polylineLayer = null;
            }


            if (this.movingMarker) {
                this.movingMarker.stopMove();
                this.movingMarker.setMap(null);
                this.movingMarker = null;
            }
            if (this.routeMarker) {
                this.routeMarker.setMap(null);
                this.routeMarker = null;
            }

            // 重置地图视图到初始位置
            this.Map.easeTo({
                center: new TMap.LatLng(this.selectedItem ? this.selectedItem.latitude : 39.819988, this.selectedItem ? this.selectedItem.precision : 116.347422),
                zoom: 100,
                pitch: 0,
                rotation: 0
            });

            this.isMoving = false;
        },

        searchBtns(){

         // 清除之前的学生标记
         this.value1 = []
         if (this.studentMarkersFromFindReadingStudent2) {
             this.studentMarkersFromFindReadingStudent2.setMap(null);
             this.studentMarkersFromFindReadingStudent2 = null;
         }
         if (this.studentMarkersFromShowStudentMarkers) {
             this.studentMarkersFromShowStudentMarkers.setMap(null);
             this.studentMarkersFromShowStudentMarkers = null;
         }


         // 清除连线
         if (this.polylineLayer) {
              this.polylineLayer.setMap(null);
              this.polylineLayer = null;
         }
 
         // 重置标记点位置
         this.firstMarkerPosition = null;
         this.secondMarkerPosition = null;
         this.firstMarkerId = null;
         this.secondMarkerId = null;


          const [year, month] = this.value8 ? this.value8.split("-") : [];
          const [year1, month1] = this.weekNumber.length > 0 ? this.weekNumber : [];

          if(this.value11 === 1){
            this.handleselectStudentSite(this.value6, '', '')
          }
          else if(this.value11 === 2){
            this.handleselectStudentSite('',year1, month1)
          }
          else if(this.value11 === 3){
            this.handleselectStudentSite('',year, month)
          }
          else{
            this.handleselectStudentSite('','', '')
          }
        },

        initMap (lng = 39.819988,lat = 116.347422 ) {
            // 确保TMap对象存在
            if (typeof TMap === 'undefined') {
                this.$message.error('地图API未加载完成，请稍后再试');
                return;
            }

            this.Map = new TMap.Map(document.getElementById('container'), {
                center: new TMap.LatLng(lng, lat),
                zoom: 16,
                pitch: 0,
                rotation: 0,
                draggable: true,
                showControl: true,
            });

            // this.haandleLocateUser();

            // 延迟初始化测量工具，确保地图和工具库都已加载
            setTimeout(() => {
                try {
                    if (TMap && TMap.tools && TMap.tools.MeasureTool) {
                        this.measureTool = new TMap.tools.MeasureTool({
                            map: this.Map,
                            showResult: true,
                            cursor: 'crosshair',
                            drawStyle: {
                                color: '#1791fc',
                                opacity: 1,
                                weight: 4
                            }
                        });
                    } else {
                        console.error('TMap.tools.MeasureTool not found');
                        this.$message.error('测量工具加载失败，请确保已引入测量工具库');
                    }
                } catch (error) {
                    console.error('测量工具初始化错误:', error);
                    this.$message.error('测量工具初始化失败');
                }
            }, 1000);


            this.Map.on("click", (evt) =>{
                let lat = evt.latLng.getLat().toFixed(6);
                let lng = evt.latLng.getLng().toFixed(6);
                console.log(evt)
                this.contentinnerHTML = lat + "," + lng;
            })


        },

        getWeekNumber(date) {
            if(date){
                const targetDate = new Date(date.getTime());
                const startOfYear = new Date(targetDate.getFullYear(), 0, 4);
                const dayOfWeek = (startOfYear.getDay() + 6) % 7;
                const startOffset = dayOfWeek >= 4 ? 0 : 7;
                const startDateOfFirstWeek = new Date(startOfYear.setDate(startOfYear.getDate() - dayOfWeek + startOffset));
                const diffTime = targetDate - startDateOfFirstWeek;
                const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                const weekNumber = Math.ceil((diffDays + 1) / 7);
                const res = [date.getFullYear(), weekNumber]
                // `${date.getFullYear()} 年 - 第 ${weekNumber} 周`
                this.weekNumber = res;
            }else{
                this.weekNumber = '';
            }
            
        },

        haandleLocateUser(lng = 39.819988, lat = 116.347422) {
            const defaultCenter = new TMap.LatLng(lng, lat);
            this.Map.setCenter(defaultCenter);
            this.haandleAddUserMarker(defaultCenter);
        },

        haandleAddUserMarker(position) {
                // this.marker = new TMap.MultiMarker({
                //     map: this.Map,
                //     styles: {
                //         marker: new TMap.MarkerStyle({
                //             width: 25,
                //             height: 35,
                //             anchor: { x: 16, y: 32 },
                //             src: 'https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/markerDefault.png',
                //         }),
                //     },
                //     geometries: [
                //         {
                //            position,
                //            styleId: 'marker',
                //            id: 'marker',
                //            properties: {
                //                 "title": "marker1"
                //            }
                //         },
                //     ],
                // });



               
                let names = ''
                if(this.optionList11.length > 0){
                    names = this.optionList11.find(item => item.id === this.value2)
                }

                // Create info window
                const infoWindow = new TMap.InfoWindow({
                    map: this.Map,
                    position: position,
                    offset: new TMap.Point(-2, -25),
                    content: `
                        <div style="padding: 10px;">
                            <h4 style="margin: 0 0 5px;">当前位置</h4>
                            <p style="margin: 0;">纬度: ${position.lat.toFixed(6)}</p>
                            <p style="margin: 5px 0 0;">经度: ${position.lng.toFixed(6)}</p>
                        </div>
                    `,
                    zIndex: 999,
                });
                
                // Hide info window initially
                infoWindow.close();

                // Add click event listener to marker
                this.marker.on('click', (evt) => {
                    
                    let names = ''
                    if(this.optionList11.length > 0){
                        names = this.optionList11.find(item => item.id === this.value2)
                    }

                    if(names){
                        infoWindow.setContent(`
                            <div style="padding: 1px;">
                                <h4 style="margin: 0 0 5px;">${ names ? '老师：' + names.realname : '当前位置' }</h4>
                            </div>
                        `)
                        
                        infoWindow.open();
                        infoWindow.setPosition(evt.geometry.position);
                    }else{
                        this.$message({ message: '请选择老师', type: "warning" });
                    }

                });
        },
        
        // 添加显示学生位置的方法
        showStudentMarkers(studentsData) {

            console.log(studentsData, '>>>>>>学生数据')

            // 如果已存在标记，先清除（仅清除由 showStudentMarkers 创建的标记点）
            if (this.studentMarkersFromShowStudentMarkers) {
                this.studentMarkersFromShowStudentMarkers.setMap(null);
            }

            // 准备标记点样式
            const styles = {
                green: new TMap.MarkerStyle({
                    width: 35,
                    height: 40,
                    anchor: { x: 16, y: 32 },
                    src: this.markerIcons.green
                }),
                red: new TMap.MarkerStyle({
                    width: 35,
                    height: 40,
                    anchor: { x: 16, y: 32 },
                    src: this.markerIcons.red
                }),
                yellow: new TMap.MarkerStyle({
                    width: 35,
                    height: 40,
                    anchor: { x: 16, y: 32 },
                    src: this.markerIcons.yellow
                }),
                pink: new TMap.MarkerStyle({
                    width: 35,
                    height: 40,
                    anchor: { x: 16, y: 32 },
                    src: this.markerIcons.pink
                }),
                blue: new TMap.MarkerStyle({
                    width: 35,
                    height: 40,
                    anchor: { x: 16, y: 32 },
                    src: this.markerIcons.blue
                }),
            };

            // 过滤掉 lat 或 lng 为 null 的数据
            let validStudentsData = studentsData.filter(student => student.lat !== null && student.lng !== null);


            console.log(validStudentsData, '>>>>>>有效学生数据')
            

            // 判断studentsData如果为空的[] 就不执行下面的代码
            if (validStudentsData.length === 0) {
                this.$message.warning('没有学生数据可供显示');
                return;
            }

            // 准备标记点数据
            let geometries = validStudentsData.map((student, index) => ({
                    id: student.id,
                    position: new TMap.LatLng(student.lng, student.lat),
                    styleId: student.status === 'green' ? 'green' : 
                            student.status === 'red' ? 'red' : 
                            student.status === 'yellow' ? 'yellow' : 
                            student.status === 'blue' ? 'blue' : 
                            'blue', // 默认设置为蓝色
                    properties: {
                        id: student.id,
                        title: student.name,
                        subject: student.subject,
                        address: student.address,
                        sex: student.sex,
                        avatar: student.avatar,
                    }
            }));


            // 创建多个标记点
            this.studentMarkersFromShowStudentMarkers = new TMap.MultiMarker({
                map: this.Map,
                styles: styles,
                geometries: geometries
            });

            // 调整地图视野以包含所有标记点
            const bounds = new TMap.LatLngBounds();
            geometries.forEach(geo => bounds.extend(geo.position));
            this.Map.fitBounds(bounds, {
                padding: 100 // 设置边距，确保标记点不会太靠近地图边缘
            });

            // 添加所有学生位置到边界
            geometries.forEach(geo => {
                bounds.extend(geo.position);
            });
            
            // 调整地图视野以包含所有标记点
            this.Map.fitBounds(bounds, {
                padding: 100 // 设置边距，确保标记点不会太靠近地图边缘
            });

            
            this.studentMarkersFromShowStudentMarkers.on('hover', (evt) => {

                console.log(evt, 'hover----------》》》')

                const { id, position, properties } = evt.geometry || {};
                if (!id || !position || !properties) {
                    console.warn('hover 事件的 geometry 数据不完整:', evt);
                    return;
                }


                // 计算与老师的距离
                let distanceText = '未知距离';
                if (this.marker) {
                    this.selectedEnd = { lat: position.lat, lng: position.lng };
                    const teacherPosition = this.marker.getGeometries()[0].position;
                    const distance = this.calculateDistance(
                        teacherPosition.lat, 
                        teacherPosition.lng,
                        position.lat,
                        position.lng
                    );
                    distanceText = distance < 1 ? 
                                  `${(distance * 1000).toFixed(0)}米` : 
                                  `${distance.toFixed(1)}Km（公里）`;
                }
                
                // 如果该标记的信息窗口不存在，则创建
                if (!this.studentInfoWindows[id]) {
                    this.studentInfoWindows[id] = new TMap.InfoWindow({
                        map: this.Map,
                        position: position,
                        offset: new TMap.Point(-2, -25),
                        content: `
                            <div>
                                <h4 style="margin: 0 0 5px;">学生信息</h4>
                                <p style="margin: 0;">姓名: ${properties.title}</p>
                                <p style="margin: 5px 0 0;">科目: ${properties.subject ? properties.subject : ''}</p>
                                <p style="margin: 5px 0 0;">地址: ${properties.address ? properties.address : ''}</p>
                                <p style="margin: 5px 0 0;">性别: ${properties.sex === 1 ? '男' : properties.sex === 2 ? '女' : ''}</p>
                            </div>
                        `,
                        zIndex: 999
                    });
                }else{
                    // 更新已有弹窗的内容
                    this.studentInfoWindows[id].setContent(`
                        <div>
                            <h4 style="margin: 0 0 5px;">学生信息</h4>
                            <p style="margin: 0;">姓名: ${properties.title}</p>
                            <p style="margin: 5px 0 0;">科目: ${properties.subject ? properties.subject : ''}</p>
                            <p style="margin: 5px 0 0;">地址: ${properties.address ? properties.address : ''}</p>
                            <p style="margin: 5px 0 0;">性别: ${properties.sex === 1 ? '男' : properties.sex === 2 ? '女' : ''}</p>
                        </div>
                    `);
                }
                
                // 关闭其他所有信息窗口
                Object.values(this.studentInfoWindows).forEach((infoWindow) => infoWindow.close());

                // 打开当前标记的信息窗口
                this.studentInfoWindows[id].open();
                this.studentInfoWindows[id].setPosition(position);

                this.openID = evt
            });



            // 监听 mouseout 事件（鼠标移出时关闭信息窗口）
            this.studentMarkersFromShowStudentMarkers.on('mouseout', (evt) => {
                console.log(evt, 'mouseout----------》》》');

                const { geometry } = this.openID || {};
                if (!geometry || geometry.id === null) {
                    // 如果 evt.geometry 不存在或 id 为 null，则不执行后续操作
                    return;
                }

                const { id } = geometry;

                // 关闭当前打开的信息窗口
                if (this.studentInfoWindows[id]) {
                    this.studentInfoWindows[id].close();
                }

                // 清空 openID
                this.openID = null;
            });


            // 为每个标记点绑定点击事件
            this.studentMarkersFromShowStudentMarkers.on('click', (evt) => {
                const { id, position, properties } = evt.geometry || {};
                if (!id || !position || !properties) {
                    console.warn('click 事件的 geometry 数据不完整:', evt);
                    return;
                }
                console.log(id, position, properties, '为每个标记点绑定点击事件===1111111111111111111111===========>>>',evt.geometry)     
                this.handleMarkerClick(position, properties.title,properties.id);
            });



        },


        handleMarkerClick(position, title,id) {

            console.log(position, title, id, '点击的标记点信息==============>>>>1handleMarkerClick')
            
            if (!this.firstMarkerPosition) {
                // 保存第一个标记点的位置
                this.firstMarkerPosition = position;
                this.firstMarkerId = id; // 保存第一个标记点的 ID
                this.$message.info(`已选择第一个标记点: ${title}`);
            } else if (!this.secondMarkerPosition) {
                // 保存第二个标记点的位置
                this.secondMarkerPosition = position;
                this.secondMarkerId = id; // 保存第二个标记点的 ID
                this.$message.info(`已选择第二个标记点: ${title}`);

                // 绘制连线
                this.drawLineBetweenMarkers(this.firstMarkerPosition, this.secondMarkerPosition,this.firstMarkerId,this.secondMarkerId);

                // 重置标记点位置
                this.firstMarkerPosition = null;
                this.secondMarkerPosition = null;
                this.firstMarkerId = null; // 重置第一个标记点的 ID
                this.secondMarkerId = null; // 重置第二个标记点的 ID
            }
        },

        drawLineBetweenMarkers(startPosition, endPosition,firstMarkerId,secondMarkerId) {
            // 清除现有路线
            if (this.polylineLayer) {
                this.polylineLayer.setMap(null);
            }

            // 创建新的路线图层
            this.polylineLayer = new TMap.MultiPolyline({
                map: this.Map,
                styles: {
                    style_blue: new TMap.PolylineStyle({
                        color: '#dd129c',
                        width: 1,
                        borderWidth: 1,
                        borderColor: '#dd129c',
                        lineCap: 'round'
                    })
                },
                geometries: [{
                    id: 'line1',
                    styleId: 'style_blue',
                    paths: [startPosition, endPosition] // 连线的路径
                }]
            });

            // 调整地图视野以显示整个路线
            const bounds = new TMap.LatLngBounds();
            bounds.extend(startPosition);
            bounds.extend(endPosition);
            this.Map.fitBounds(bounds, {
                padding: 100 // 设置边距，确保连线不会太靠近地图边缘
            });

            console.log('第一个标记点ID:', firstMarkerId);
            console.log('第二个标记点ID:', secondMarkerId);

            this.handleselectStudentDistance(firstMarkerId,secondMarkerId)
            

        },

        // 添加计算两点之间距离的方法
        calculateDistance(lat1, lng1, lat2, lng2) {
            const R = 6371; // 地球半径，单位公里
            const dLat = this.toRad(lat2 - lat1);
            const dLng = this.toRad(lng2 - lng1);
            const a = 
                Math.sin(dLat/2) * Math.sin(dLat/2) +
                Math.cos(this.toRad(lat1)) * Math.cos(this.toRad(lat2)) * 
                Math.sin(dLng/2) * Math.sin(dLng/2);
            const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
            return R * c; // 返回距离，单位公里
        },

        // 角度转弧度
        toRad(degree) {
            return degree * Math.PI / 180;
        },



        displayPolyline(pl) {
        // 创建 MultiPolyline显示路径折线
            this.polylineLayer = new TMap.MultiPolyline({
                id: 'polyline-layer',
                map: this.Map,
                styles: {
                    style_blue: new TMap.PolylineStyle({
                        color: '#3777FF',
                        width: 8,
                        borderWidth: 5,
                        borderColor: '#FFF',
                        lineCap: 'round',
                    }),
                },
                geometries: [
                    {
                        id: 'pl_1',
                        styleId: 'style_blue',
                        paths: pl,
                    },
                ],
            });
        },


        formatDrivingRoute(result) {
            const route = result.result.routes[0];
            return {
                duration: this.formatDuration(route.duration),
                distance: this.formatDistance(route.distance),
                steps: route.steps.map((step, index) => 
                    `<p>${index + 1}. ${step.instruction}</p>`
                ).join('')
            };
        },

        formatTransitRoute(result) {
            const route = result.result.routes[0];
            return {
                duration: this.formatDuration(route.duration),
                distance: this.formatDistance(route.distance),
                steps: route.steps.map((step, index) => {
                    if (step.type === 'TRANSIT') {
                        return `<p>${index + 1}. 乘坐${step.lines[0].title} (${step.lines[0].stations.length}站)</p>`;
                    }
                    return `<p>${index + 1}. ${step.instruction}</p>`;
                }).join('')
            };
        },

        formatWalkingRoute(result) {
            const route = result.result.routes[0];
            return {
                duration: this.formatDuration(route.duration),
                distance: this.formatDistance(route.distance),
                steps: route.steps.map((step, index) => 
                    `<p>${index + 1}. ${step.instruction}</p>`
                ).join('')
            };
        },

        formatDuration(seconds) {
            if (!seconds || seconds <= 0) {
                return '0分钟';
            }

            const hours = Math.floor(seconds / 3600); // 计算小时
            const minutes = Math.floor((seconds % 3600) / 60); // 计算分钟
            const remainingSeconds = seconds % 60; // 计算剩余秒数

            let result = '';
            if (hours > 0) {
                result += `${hours}小时`;
            }
            if (minutes > 0) {
                result += `${minutes}分钟`;
            }
            if (remainingSeconds > 0 && hours === 0 && minutes === 0) {
                result += `${remainingSeconds}秒`;
            }
            return result || '0分钟';
        },

        formatDistance(meters) {
            if (meters >= 1000) {
                return `${(meters / 1000).toFixed(1)}公里`;
            }
            return `${Math.round(meters)}米`;
        },

        // 添加获取路线的方法
        getRoute(type, startPosition, endPosition) {
            return new Promise((resolve, reject) => {
                const callbackName = `jsonp_route_${type}_${Math.random().toString(36).substr(2, 9)}`;
                const script = document.createElement('script');

                const baseUrl = 'https://apis.map.qq.com/ws/direction/v1';
                const url = `${baseUrl}/${type}/?from=${startPosition.lat},${startPosition.lng}&to=${endPosition.lat},${endPosition.lng}&key=V2CBZ-VZZET-O6SXA-LIJJX-7NZ23-KWBXD&output=jsonp&callback=${callbackName}`;

                window[callbackName] = (response) => {
                    if (response.status === 0) {
                        const route = response.result.routes[0];
                        const path = this.decodePolyline(route.polyline);

                        // 确保 steps 是数组
                        const steps = Array.isArray(route.steps) ? route.steps.map((step) => step.instruction) : [];

                        resolve({
                            duration: route.duration,
                            distance: route.distance,
                            steps: steps, // 确保 steps 是数组
                            path: path
                        });
                    } else {
                        reject(new Error(response.message));
                    }

                    document.body.removeChild(script);
                    delete window[callbackName];
                };

                script.onerror = () => {
                    reject(new Error(`${type}路线规划服务出错`));
                    document.body.removeChild(script);
                    delete window[callbackName];
                };

                script.src = url;
                document.body.appendChild(script);
            });
        },
        // 显示地铁路线
        showSelectedRoutes(path) {
            // 清除现有路线
            if (this.polylineLayer) {
                this.polylineLayer.setMap(null);
            }
            
            // 创建新的路线图层
            this.polylineLayer = new TMap.MultiPolyline({
                map: this.Map,
                styles: {
                    style_blue: new TMap.PolylineStyle({
                        color: '#dd129c',
                        width: 1,
                        borderWidth: 1,
                        borderColor: '#dd129c',
                        lineCap: 'round'
                    })
                },
                geometries: [{
                    id: 'path1',
                    styleId: 'style_blue',
                    paths: path
                }]
            });

            // 调整地图视野以显示整个路线
            const bounds = new TMap.LatLngBounds();
            path.forEach(point => bounds.extend(point));
            this.Map.fitBounds(bounds, {
                padding: 100
            });
        },
        // 添加显示选中路线的方法
        showSelectedRoute(path) {
            // 清除现有路线
            if (this.polylineLayer) {
                this.polylineLayer.setMap(null);
            }
            
            // 创建新的路线图层
            this.polylineLayer = new TMap.MultiPolyline({
                map: this.Map,
                styles: {
                    style_blue: new TMap.PolylineStyle({
                        color: '#2A88FF',
                        width: 5,
                        borderWidth: 3,
                        borderColor: '#0569FF',
                        lineCap: 'round'
                    })
                },
                geometries: [{
                    id: 'path1',
                    styleId: 'style_blue',
                    paths: path
                }]
            });

            // 调整地图视野以显示整个路线
            const bounds = new TMap.LatLngBounds();
            path.forEach(point => bounds.extend(point));
            this.Map.fitBounds(bounds, {
                padding: 100
            });
        },

        planRoute(lat, lng) {
            if (!this.isValidCoordinate(lat, lng)) {
                console.error(`无效的路线坐标: lat=${lat}, lng=${lng}`);
                return;
            }
            // 调用地图 API 规划路线
            mapApi.planRoute(lat, lng);
        },

        addStartEndMarkers(startPosition, endPosition) {
            // 清除现有的起点和终点标记
            if (this.routeMarker) {
                this.routeMarker.setMap(null);
                this.routeMarker = null;
            }

            // 创建起点和终点标记
            this.routeMarker = new TMap.MultiMarker({
                map: this.Map,
                styles: {
                    start: new TMap.MarkerStyle({
                        width: 32, // 图标宽度
                        height: 32, // 图标高度
                        anchor: { x: 16, y: 32 }, // 锚点设置为图标底部中心
                        src: 'https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/start.png' // 起点图标
                    }),
                    end: new TMap.MarkerStyle({
                        width: 32, // 图标宽度
                        height: 32, // 图标高度
                        anchor: { x: 16, y: 32 }, // 锚点设置为图标底部中心
                        src: 'https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/end.png' // 终点图标
                    })
                },
                geometries: [
                    {
                        id: 'start',
                        styleId: 'start',
                        position: startPosition
                    },
                    {
                        id: 'end',
                        styleId: 'end',
                        position: endPosition
                    }
                ]
            });
        },
        startMovings() {
            this.routeInfoVisible = false;
        },
        startMoving() {
            if (!this.drivingPath || this.drivingPath.length === 0) {
                this.$message.warning('请先规划路线');
                return;
            }

            if (this.isMoving) {
                this.$message.warning('车辆正在移动中');
                return;
            }

            // 创建移动标记
            if (this.movingMarker) {
                this.movingMarker.setMap(null);
            }

            this.movingMarker = new TMap.MultiMarker({
                map: this.Map,
                styles: {
                    'car': new TMap.MarkerStyle({
                        width: 48,
                        height: 72,
                        anchor: { x: 24, y: 36 },
                        faceTo: 'map',
                        src: 'https://mapapi.qq.com/web/mapComponents/componentsTest/zyTest/static/model_taxi.png'
                    })
                },
                geometries: [{
                    id: 'car',
                    styleId: 'car',
                    position: this.drivingPath[0]
                }]
            });

            // 设置地图视角
            this.Map.easeTo({
                center: this.drivingPath[0],
                zoom: 16,
                pitch: 45
            }, {
                duration: 1000
            });

            // 开始移动动画
            let totalDistance = 0;
            setTimeout(() => {
                this.movingMarker.moveAlong({
                    car: {
                        path: this.drivingPath,
                        speed: 80,  // 设置速度
                        delay: 50   // 减少延迟使移动更流畅
                    }
                }, {
                    autoRotation: true,
                    smooth: true
                });

                this.isMoving = true;

                // 移动过程中的事件监听
                this.movingMarker.on('moving', (e) => {
                    if (!e.car || !e.car.passedLatLngs.length) return;

                    const lastIdx = e.car.passedLatLngs.length - 1;
                    const currentPos = e.car.passedLatLngs[lastIdx];

                    // 计算已移动的距离
                    if (lastIdx > 0) {
                        const prevPos = e.car.passedLatLngs[lastIdx - 1];
                        totalDistance += this.calculateDistance(
                            prevPos.lat, prevPos.lng,
                            currentPos.lat, currentPos.lng
                        );
                    }

                    // 更新实时距离
                    this.routeInfo.realTimeDistance = this.formatDistance(totalDistance);

                    // 更新相机位置，使其更紧密地跟随车辆
                    this.Map.easeTo({
                        center: currentPos,
                        rotation: e.car.angle,
                        pitch: 60,
                        zoom: 18
                    }, {
                        duration: 100
                    });
                });

                // 移动结束事件
                this.movingMarker.on('move_ended', () => {
                    this.isMoving = false;
                    this.$message.success('移动完成');
                });
            }, 500);
        },

  }

}
</script>



<style>


.route-info-box {
    position: absolute;
    top: 35%;
    left: 19%;
    width: 300px;
    height: 300px;
    overflow-y: auto;
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 5px;
    padding: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    z-index: 1000;
}

.route-info-box h3 {
    margin: 0 0 10px;
    font-size: 16px;
    color: #409EFF;
}

.route-info-box p {
    margin: 5px 0;
    color: #606266;
}

.route-info-box ul {
    padding-left: 20px;
    list-style-type: disc;
}

.route-info-box ul li {
    margin: 5px 0;
    color: #606266;
}


/* 全局样式 - 消息框相关 */
.el-message-box {
    width: 30% !important;
    height: 30% !important;
    margin-left: -571px;
    max-height: 80vh !important;
    overflow-y: auto !important;
    flex-direction: column !important;
}

.el-message-box__content {
    flex: 1 !important;
    overflow-y: auto !important;
    padding: 20px !important;
}

.route-dialog .route-details {
    max-height: none !important;
}
</style>

<style scoped lang="less">
/* 局部作用域样式 */
body {
    height: 100%;
    margin: 0px;
    padding: 0px;
    overflow: hidden;
}

#container {
    position: absolute;
    width: 81.6%;
    height: 65%;
    margin-top: 10px;
}

/deep/.el-form-item{
    margin-bottom: 15px !important;
}

/deep/.el-card__body{
    padding: 20px 20px 0px 20px !important;
}

.radius_box{
    position: absolute;
    bottom: 55px;
    right: 10px;
    background: #fffbfb;
    width: 60px;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    color: #23a9fa;
    z-index: 99999;
    opacity: 0.8;
}

.icon-circle{
    position: absolute;
    display: flex;
    right: 125%;
}

.icon-button{
    margin-right: 5px;
}

.distance-box{
    position: absolute;
    left: 22%;
    top: 38%;
    z-index: 11111111;
}

.distance-box-Coordinate{
    position: absolute;
    left: 22%;
    top: 38%;
    z-index: 11111111;
}

/deep/.el-select-dropdown /deep/.el-popper{
    z-index: 111111111111 !important;
}

/* 路线信息对话框样式 */
.route-dialog {
    .route-details {
        max-height: 60vh;
        overflow-y: auto;
        padding: 0 10px;

        .route-section {
            margin-bottom: 20px;
            padding-bottom: 15px;
            border-bottom: 1px solid #eee;

            &:last-child {
                border-bottom: none;
            }

            h3 {
                color: #409EFF;
                margin: 10px 0;
                font-size: 16px;
            }

            p {
                margin: 5px 0;
                color: #606266;
                line-height: 1.5;
            }

            .route-steps {
                margin-top: 10px;
                padding-left: 15px;
                
                p {
                    position: relative;
                    padding-left: 20px;
                    font-size: 14px;
                    
                    &:before {
                        content: "•";
                        position: absolute;
                        left: 0;
                        color: #409EFF;
                    }
                }
            }
        }
    }
}

/* 路线信息对话框样式补充 */
.route-info-dialog {
    max-width: 600px !important;
}

.route-info-dialog .el-message-box__content {
    padding: 20px;
}

.route-info-dialog h3 {
    color: #409EFF;
    margin-top: 10px;
    margin-bottom: 10px;
}

.route-info-dialog p {
    margin: 5px 0;
    color: #606266;
}


</style>



// WEBPACK FOOTER //
// src/rangeQueryMap/rangeQueryMap.vue